// src/App.js
import React, { useState } from 'react';
import { Router, Routes, Route, useLocation } from 'react-router-dom';
//import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import './styles/calculator.css';
//import { BrowserRouter as Router, Link, Routes, useLocation, Route } from 'react-router-dom';
/* import './App.css';  */// Your general App styles - this is where we'll add the magic!
// Importa preact-compat para que React pueda renderizar los componentes AMP


import Header from './components/Header';
import Footer from './components/Footer';


// Import your page components
import MenuPage from './components/MenuPage';
import IndemnizacionForm from './components/IndemnizacionForm';
/* import Form2 from './components/Form2';
import Form3 from './components/Form3'; */
import CreditSimulator from './components/CreditSimulator';
import SalarioCalculator from './components/SalarioCalculator';
import PresupuestoDetallado from './components/PresupuestoDetallado';
import AguinaldoForm from './components/AguinaldoForm';

//const headerStyle = Link.pathname === '/' ? { height: '725px' } : {  };
//const headerStyle = { height: '725px' };



function App() {
  const BaseUrl = "/calculadoras-financieras";
  //const BaseUrl = "/calculadoras-financieras/ads/build/";
  const location = useLocation();
  const { pathname } = location
  const headerStyle = (pathname === '/calculadoras-financieras/simulador-de-creditos' || pathname === '/calculadoras-financieras/calculo-salario' || pathname === '/calculadoras-financieras/presupuesto') ? { } : { height: '53vh' };
  const [divStyle, setDivStyle] = useState({
  backgroundColor: '#343a40',
  color: 'white',
  padding: '1rem 0',
  marginTop: '25rem'
  });  
  return (

      <div className="app-container"> {/* This is the main container that will use flexbox */}
        <Header />
        <main style={headerStyle}>  {/* The main content area will grow */}
           {/* Pathname: <b>{pathname}</b><br /> */}
          <Routes basename={BaseUrl} >
            <Route path="/calculadoras-financieras" element={<MenuPage />} />
            <Route path="/calculadoras-financieras/indemnizacion" element={<IndemnizacionForm />} />
            <Route path="/calculadoras-financieras/aguinaldo" element={<AguinaldoForm />} />
{/*             <Route path="/form2" element={<Form2 />} />
            <Route path="/form3" element={<Form3 />} /> */}
            <Route path="/calculadoras-financieras/simulador-de-creditos" element={<CreditSimulator />} />
            <Route path="/calculadoras-financieras/calculo-salario" element={<SalarioCalculator />} />
            <Route path="/calculadoras-financieras/presupuesto" element={<PresupuestoDetallado />} />
          </Routes>
        </main>
        <Footer dvstyle = {divStyle} />
      </div>

  );
}

export default App;